import * as Yup from "yup";
import {yupRequiredPositiveNumber, yupRequiredPositiveOrZeroNumber, yupRequiredString,} from "../yup/Validators";

export const UpsertRequirementSchema = Yup.object().shape({
  resourceTypeId: yupRequiredString,
  quantity: yupRequiredPositiveNumber,
  unitPrice: yupRequiredPositiveOrZeroNumber,
});
